import {Children, ClassComponent, Vnode} from 'mithril';
import BlockEmbed from './BlockEmbed';
import Icon from './Icon';
import {RichEmbedAttrs} from './RichEmbed';
import labelIsSameAsLink from '../utils/labelIsSameAsLink';
import RichImage from './RichImage';

export default class InlineEmbed implements ClassComponent<RichEmbedAttrs> {
    view(vnode: Vnode<RichEmbedAttrs, this>) {
        const {embed, childImage} = vnode.attrs;

        // If the image is wrapped by a link to itself, drop the inline wrapper completely
        // as it would just show duplicate information
        if (childImage?.embed.id() === embed.id()) {
            return this.image(vnode);
        }

        return [
            m('span.rich-embed-inline', childImage ? this.image(vnode) : [
                m(Icon, {
                    embed,
                    inline: true,
                }),
                ' ',
                this.label(vnode),
            ]),
            m('span.rich-embed-float-wrapper', m(BlockEmbed, vnode.attrs)),
        ];
    }

    label(vnode: Vnode<RichEmbedAttrs, this>): Children {
        const {embed, labelHtml} = vnode.attrs;

        // If the embed is still loading or if it's a customized label, display the original link label
        if (embed.state() !== 'ready' || !labelIsSameAsLink(labelHtml, embed.id()!)) {
            return m.trust(labelHtml || '');
        }

        const preview = embed.preview() || {};

        if (preview.inlineTitle) {
            return preview.inlineTitle;
        }

        if (preview.title) {
            return preview.title;
        }

        // If all else fails, return the original label, even if it's the URL itself
        return m.trust(labelHtml || '');
    }

    image(vnode: Vnode<RichEmbedAttrs, this>): Children {
        // We need to re-create the wrapping span because unlike in the normal preview script
        // we can't preserve the existing tag to use as component mount point
        return m('span.inline-img.rich-embed-img', m(RichImage, vnode.attrs.childImage));
    }
}
